var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.52 52.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.34,
    "data-name": "Layer 29"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1.67 1.67h18.92v18.92H1.67zm32.27 0h18.92v18.92H33.94zM1.67 31.71h18.92v18.92H1.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M33.94 31.71h18.92v18.92H33.94z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.e2f26491.svg";
export { ForwardRef as ReactComponent };